import {
  LAIS_TRACKING_CREATORS,
  listingTrackingPayload,
  quickFilterTrackingPayload,
} from 'dashboard/helper/lais/trackingEvents';

export const LAIS_ANALYTICS_ACTIONS = Object.freeze({
  LISTING_CLICKED: 'lais/listingClicked',
  LISTING_QUICK_FILTER_CLICKED: 'lais/listingQuickFilterClicked',
});

export const handleListingAnalytics = (
  action,
  { track, defaultProps = {} } = {}
) => {
  const payload = action?.payload || {};

  switch (action?.type) {
    case LAIS_ANALYTICS_ACTIONS.LISTING_CLICKED:
      return track(
        LAIS_TRACKING_CREATORS.listingClicked,
        {
          ...defaultProps,
          ...listingTrackingPayload(payload.imovel || payload.listing, payload),
        },
        { variant: payload.variant || 'index_card' }
      );
    case LAIS_ANALYTICS_ACTIONS.LISTING_QUICK_FILTER_CLICKED:
      return track(
        LAIS_TRACKING_CREATORS.listingQuickFilterClicked,
        {
          ...defaultProps,
          ...quickFilterTrackingPayload(payload.filter, payload),
        },
        { variant: payload.variant || 'catalog_filter' }
      );
    default:
      return undefined;
  }
};

export default handleListingAnalytics;
